module.exports = __webpack_public_path__ + "img/strike-a-style_bottom.4fb941e9.png";